import { envs } from "application/envHandler";
import apiClient from "core/api/client";
import { PaginationConfig } from 'core/pagination-optimized/redux/types';
import queryString from 'core/utils/query-string';
import getMockedFrequencyScanHistoryData from "testing/rftuning/frequencyScanHistory";

type Filter = {
  value: PaginationConfig
  offset: number
}

export default async function fetchFrequencyScanHistory(id: string, assetName: string, filter?: Filter) {
  if (process.env.NODE_ENV === 'development' && envs.REACT_APP_USE_LOCAL_MOCKED_DATA) {
    const data = await getMockedFrequencyScanHistoryData()

    return { ...data }
  }

  return apiClient
    .get(
      `${envs.REACT_APP_API_URL
      }/device/${id}/rf-tuning/history?assetName=${assetName}&${queryString(
        filter?.value,
        filter?.offset
      )}`
    )
}